import { useContext } from "react";
import { Link } from "react-router-dom";
// import appStore from "../../../../assets/img/logo/app-store.png";
import googlePlay from "../../../../assets/img/logo/google-play-w.png";
import { RESPINOS_LINK } from "../../../../config/constant";
import { GlobalContext } from "../../../contexts/globalContext";

const navigations = [
  { label: "Tentang Aplikasi", path: "/about" },
  { label: "FAQ", path: "/faq" },
];

const AsideDashboard = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  return (
    <aside
      className="hidden sm:block w-full xl:w-72 px-3 pt-6 pb-40 xl:pb-16 flex-shrink-0 border-t xl:border-t-0 xl:border-r-2 relative"
      style={{ minHeight: "calc(100vh - 50px)" }}
    >
      {/* USER INFORMATION */}
      <div>
        <div className="mt-8 flex justify-center xl:justify-start space-x-6 items-center">
          <div
            className="w-20 h-20 rounded-full bg-cover bg-center"
            style={{
              backgroundImage: `url("${sharedState.user.profile.avatar}")`,
            }}
          />
          <div className="leading-none">
            <div className="text-lg font-semibold text-gray-800">
              {sharedState.user.name}
            </div>
            <div className="-mt-0.5 text-gray-600 text-opacity-50 text-sm">
              {sharedState.user.email}
            </div>
          </div>
        </div>

        <p className="mt-5 text-center xl:text-left">
          {sharedState.user.profile.description || "Belum ada deskripsi."}
        </p>
      </div>

      <hr className="mt-6 " />
      {/* NAVIGATION */}
      <div className="mt-6 text-center xl:text-left">
        <div className="font-semibold uppercase text-sm text-gray-800">
          Navigasi
        </div>
        <ul className="list-inside list-disc mt-1">
          {navigations.map((navigation) => (
            <li className="mt-0.5" key={"aside-" + navigation.label}>
              <Link to={navigation.path}>
                <span className="cursor-pointer">{navigation.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* APP INFO */}
      <div className="mt-6 text-center xl:text-left">
        <div className="font-semibold uppercase text-sm text-gray-800">
          Aplikasi
        </div>
        <p>
          Respiration diagnosis with smart app monitoring. Also available on
          smartphone.
        </p>
        <div className="flex space-x-2 mt-3 justify-center xl:justify-start">
          <a
            href={RESPINOS_LINK.android}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={googlePlay} alt="" className="h-6 cursor-pointer" />
          </a>
          {/* <img src={appStore} alt="" className="h-8 cursor-pointer" /> */}
        </div>

        <div className="text-sm absolute mb-8 xl:mb-0 bottom-10 xl:bottom-2 w-full">
          <div className="text-center">
            <p>Copyright &copy; 2021</p>
            <p>PT. Xirka Dama Persada</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AsideDashboard;
